<span class="software-tags">
    {{ displayableTags.tags.join(', ') }}
    <span class="darker" *ngIf="displayableTags.more">e mais...</span>
</span>
